/* @flow */
import * as React from "react";
import styled, { css } from "styled-components";

const Container = styled.label`
  display: inline-block;
  vertical-align: bottom;
  width: 104px;
  padding: 0 6px;
  box-sizing: border-box;
  text-align: left;

  @media(max-width: 639px) {
    width: 79px;
  }

  @media(max-width: 567px) {
    width: 69px;
  }
`;

const InputView = styled.input`
  display: inline-block;
  width: 100%;
  box-sizing: border-box;
  min-height: 27px;
  height: 29px;
  border: 1px solid ${props => props.invalid ? props.theme.lower : props.theme.borderMainColor};
  border-radius: 3px;
  font-weight: 300;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 27px;
  color: ${({ theme }) => theme.foreground};
  padding: 0 7px;
  background-color: ${props => props.theme.mainHighlight};
  box-shadow: inset 0px 2px 0px 0px rgba(0,0,0,.15);

  :focus {
    outline: none;
  }
`;

const Label = styled.div`
  direction: ${props => props.theme.direction};
  margin: 5px 0;
  padding: 0;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1;
  color: #99959d;

  ${props => props.theme.direction === "rtl" && css`
    text-align: right;
  `};
`;

type Props = {
  label: React.Node,
  name: string,
  type?: string,
  value: any,
  invalid: boolean,
  onChange: (value: any) => void
};

export function Input(props: Props) {
  const id = Math.random().toString(36).slice(2, 16);

  return (
    <Container htmlFor={id}>
      <Label>
        {props.label}:
      </Label>
      <InputView
        id={id}
        name={props.name}
        type={props.type || "tel"}
        value={props.value}
        onChange={props.onChange}
        invalid={props.invalid}
      />
    </Container>
  );
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Popup/Input.js